module.exports = __webpack_public_path__ + "img/fi-pht-valmennus.17dc2a5f.png";